/**
 * 生成作成素材関連の定数 ====================================================================================
 */

export const defaultFont = "50px keifont";
export const defaultIconFont = "200px icomoon";

/**
 * 編集ボタン関連の定数 ====================================================================================
 */

// ボタンの表示位置の設定
export const operationButtonPositions = {
  1: { x: 0, y: 0 }, // 左上
  2: { x: 0, y: 0.5 }, // 左中
  3: { x: 0, y: 1 }, // 左下
  4: { x: 0.5, y: 0 }, // 中上
  5: { x: 0.5, y: 1 }, // 中下
  6: { x: 1, y: 0 }, // 右上
  7: { x: 1, y: 0.5 }, //右中
  8: { x: 1, y: 1 }, // 右下
};

export const operationButtonWidth = 40;
export const operationButtonHeight = 40;
export const operationButtonPropertyMap = {
  delete: {
    buttonPositionNo: 3,
    buttonName: "delete",
    labelText: "削除",
    buttonColor: "#ec6d51",
    buttonIcon: "ea0f",
    textOffsetY: 16,
    iconOffsetY: 16,
    functionName: "getDeleteButtonOperations",
  },
  reset: {
    buttonPositionNo: 1,
    buttonName: "reset",
    labelText: "戻す",
    buttonColor: "#93ca76",
    buttonIcon: "e965",
    textOffsetY: 16,
    iconOffsetY: 16,
    functionName: "getResetButtonOperations",
  },
  copy: {
    buttonPositionNo: 6,
    buttonName: "copy",
    labelText: "複製",
    buttonColor: "#93ca76",
    buttonIcon: "e92e",
    textOffsetY: 16,
    iconOffsetY: 16,
    functionName: "getCopyButtonOperations",
  },
  /*front: {
    buttonName: "front",
    labelText: "前へ",
    buttonColor: "#93ca76",
    buttonIcon: "ea46",
    textOffsetY: 16,
    iconOffsetY: 10,
    buttonPositionX: 0,
    buttonPositionY: 0,
    functionName: "getFrontButtonOperations",
  },
  behind: {
    buttonName: "behind",
    labelText: "後へ",
    buttonColor: "#93ca76",
    buttonIcon: "ea47",
    textOffsetY: 16,
    iconOffsetY: 10,
    buttonPositionX: 0,
    buttonPositionY: 0.5,
    functionName: "getBehindButtonOperations",
  },*/
  zoom: {
    buttonPositionNo: 8,
    buttonName: "zoom",
    labelText: "拡縮",
    buttonColor: "#93ca76",
    buttonIcon: "e989",
    textOffsetY: 16,
    iconOffsetY: 16,
    functionName: "getZoomButtonOperations",
  },
  rotation: {
    buttonPositionNo: 7,
    buttonName: "rotation",
    labelText: "回転",
    buttonColor: "#93ca76",
    buttonIcon: "e984",
    textOffsetY: 16,
    iconOffsetY: 16,
    functionName: "getRotationButtonOperations",
  },
  /*changeColor: {
    buttonName: "changeColor",
    labelImageSrc: "/app/assets/img/deco_ui/deco_change_color.png",
    buttonPositionX: 0.5,
    buttonPositionY: 1,
    functionName: "getChangeColorButtonOperations",
    baseImageSrc: "/app/assets/img/deco_ui/icon_edit_change_color_base.png",
    showFunction: "showChangeColorButton",
  },*/
};

/**
 * 編集タイプ ====================================================================================
 */

export const decoType = {
  normalText: 1, // 通常テキスト
  outlineText: 2, // 縁付きテキスト
  normalImage: 3, // 貼るだけ作成素材
  monoImage: 4, // 色を変えられる作成素材
};

/**
 * 画像のデフォルトサイズ ====================================================================================
 */

export const defaultSizeMap = {};

// もっといい書き方ありそう
defaultSizeMap[decoType.normalImage] = 200;
defaultSizeMap[decoType.monoImage] = 200;

export const decoMinSize = 20;
export const decoMaxSize = 750;

export const decoMaxNum = 120;

/**
 * ボタンのサイズ制限 ====================================================================================
 */

export const buttonMinSize = 145;
export const buttonMaxSize = 660;

/**
 * trimページのcanvas情報 ====================================================================================
 */

export const trimPageCanvasVisibleWidth = 750;
export const trimPageCanvasVisibleHeight = 750;
export const trimPageMargin = 140;

/**
 * END==================================================================================================================
 */
